import {put, takeLatest, call} from 'redux-saga/effects';
import * as categoryService from "../../../services/categoryService"
import {
    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    ADD_CATEGORY_ERROR
}
    from "../../actions/category";

function* addCategorySaga(action) {
    try {
        const data =  yield call(categoryService.AddCategory, action.payload)
        yield put({
            type: ADD_CATEGORY_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_CATEGORY_ERROR,error: error.data
        });
    }
}

export function* addCategorySagaWatcher() {
    yield takeLatest(ADD_CATEGORY, addCategorySaga);
}